export default "__VITE_PUBLIC_ASSET__f025b424__"